/**
 * Export loadData calls from ducks modules of different containers
 */
import { loadData as AuthenticationPageLoader } from './AuthenticationPage/AuthenticationPage.duck';
import { loadData as LandingPageLoader } from './LandingPage/LandingPage.duck';
import { setInitialValues as CheckoutPageInitialValues } from './CheckoutPage/CheckoutPage.duck';
import {loadData as CheckoutPageloadData} from './CheckoutPage/CheckoutPage.duck';

import { loadData as CMSPageLoader } from './CMSPage/CMSPage.duck';
import { loadData as ContactDetailsPageLoader } from './ContactDetailsPage/ContactDetailsPage.duck';
import { loadData as EditListingPageLoader } from './EditListingPage/EditListingPage.duck';
import { loadData as EmailVerificationPageLoader } from './EmailVerificationPage/EmailVerificationPage.duck';
import { loadData as InboxPageLoader } from './InboxPage/InboxPage.duck';
import { loadData as ListingPageLoader } from './ListingPage/ListingPage.duck';
import { loadData as ManageListingsPageLoader } from './ManageListingsPage/ManageListingsPage.duck';
import { loadData as PaymentMethodsPageLoader } from './PaymentMethodsPage/PaymentMethodsPage.duck';
import { loadData as EditCouponPage } from './CreateCouponPage/CreateCoupon.duck';
import {
  loadData,
  loadData as ProfileSettingsPageLoader,
} from './ProfileSettingsPage/ProfileSettingsPage.duck';
import { loadData as PrivacyPolicyPageLoader } from './PrivacyPolicyPage/PrivacyPolicyPage.duck';
import { loadData as ProfilePageLoader } from './ProfilePage/ProfilePage.duck';
import { loadData as SearchPageLoader } from './SearchPage/SearchPage.duck';
import { loadData as SectionHeroPageLoader } from './SectionHeroPage/SectionHeroPage.duck';
import { loadData as StripePayoutPageLoader } from './StripePayoutPage/StripePayoutPage.duck';
import { loadData as TermsOfServicePageLoader } from './TermsOfServicePage/TermsOfServicePage.duck';
import { loadData as HowItWorksPageLoader } from './HowItWorksPage/HowItWorksPage.duck';
import { loadData as HowItWorksShopperPageLoader } from './HowItWorksShopperPage/HowItWorksShopperPage.duck';
import { loadData as HowItWorksMerchantsPageLoader } from './HowItWorksMerchantsPage/HowItWorksMerchantsPage.duck';
import {loadData as StripeSubscriptionPageLoader} from './StripeSubscriptionPage/StripeSubscriptionPage.duck'
import {
  loadData as TransactionPageLoader,
  setInitialValues as TransactionPageInitialValues,
} from './TransactionPage/TransactionPage.duck';
import { loadData as CartPageLoader } from './CartPage/CartPage.duck';

const getPageDataLoadingAPI = () => {
  return {
    AuthenticationPage: {
      loadData: AuthenticationPageLoader,
    },
    LandingPage: {
      loadData: LandingPageLoader,
    },
    CheckoutPage: {
      setInitialValues: CheckoutPageInitialValues,
      loadData:CheckoutPageloadData,
    },
    CMSPage: {
      loadData: CMSPageLoader,
    },
    EditCouponPage: {
      loadData: EditCouponPage,
    },
    HowItWorksPage: {
      loadData: HowItWorksPageLoader,
    },
    HowItWorksShopperPage: {
      loadData: HowItWorksShopperPageLoader,
    },
    HowItWorksMerchantsPage: {
      loadData: HowItWorksMerchantsPageLoader,
    },
    CartPage: {
      loadData: CartPageLoader,
    },
    ContactDetailsPage: {
      loadData: ContactDetailsPageLoader,
    },
    EditListingPage: {
      loadData: EditListingPageLoader,
    },
    EmailVerificationPage: {
      loadData: EmailVerificationPageLoader,
    },
    InboxPage: {
      loadData: InboxPageLoader,
    },
    ListingPage: {
      loadData: ListingPageLoader,
    },
    ManageListingsPage: {
      loadData: ManageListingsPageLoader,
    },
    SectionHeroPage: {
      loadData: SectionHeroPageLoader,
    },
    PaymentMethodsPage: {
      loadData: PaymentMethodsPageLoader,
    },
    PrivacyPolicyPage: {
      loadData: PrivacyPolicyPageLoader,
    },
    ProfilePage: {
      loadData: ProfilePageLoader,
    },
    ProfileSettingsPage: {
      loadData: ProfileSettingsPageLoader,
    },
    SearchPage: {
      loadData: SearchPageLoader,
    },
    StripePayoutPage: {
      loadData: StripePayoutPageLoader,
    },
    StripeSubscriptionPage: {
      loadData: StripeSubscriptionPageLoader,
    },
    TermsOfServicePage: {
      loadData: TermsOfServicePageLoader,
    },
    TransactionPage: {
      loadData: TransactionPageLoader,
      setInitialValues: TransactionPageInitialValues,
    },
  };
};

export default getPageDataLoadingAPI;
